import React from 'react';
import { useSelector } from 'umi';
import { MOBILE_PAGE_CONFIG } from './mobilePageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { NIGHTANGLE_PAGE_CONFIG } from './nightingalePageConfig';
import { PC_PAGE_CONFIG } from './pcPageConfig';
import './index.scss';

const reqParams = '/realtime/revenue';
const RealtimeRevenue = () => {
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile';
  });
  const pageMap: any = {
    mobile: MOBILE_PAGE_CONFIG,
    pc: PC_PAGE_CONFIG,
    pc_inflexion: NIGHTANGLE_PAGE_CONFIG,
  };
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]} />
    </>
  );
};

export default RealtimeRevenue;
